<div style="position: relative;"
     [ngStyle]="{'height': appearance.privateArea.header.height+'px',
                 'background-color': appearance.privateArea.header.bgColor, 
                 'color': appearance.privateArea.header.fontColor
                }" 
     class="horizontal layout center middle">
    <!-- 
    LEFT SECTION
    -->
    <div class="horizontal layout left middle" style="position: absolute; left: 8px; z-index: 1;">
      <!--
      BURGER MENU
      -->
      <button *ngIf="appearance.privateArea.menu && appearance.privateArea.menu.show 
                     || (appearance.privateArea.header.menu && appearance.privateArea.header.menu.show && isMobile)"
              mat-icon-button class="rightSidenav_toggle"
              style="margin-inline-end: 8px;"
              (click)="canvasLayoutDataService.toggleSidenav1()">
        <mat-icon>menu</mat-icon>
      </button>
      <!-- 
      LOGO
      -->
      <app-flipping-logo *ngIf="appearance.privateArea.header.logo.front.show"
                         [height]="isLesserThanXs ? appearance.privateArea.header.logo.front.compact.height+'px' : appearance.privateArea.header.logo.front.regular.height+'px'" 
                         [width]="isLesserThanXs ? appearance.privateArea.header.logo.front.compact.width+'px' : appearance.privateArea.header.logo.front.regular.width+'px'" 
                         [frontImage]="isLesserThanXs ? appearance.privateArea.header.logo.front.compact.src : appearance.privateArea.header.logo.front.regular.src"
                         [frontImageHeight]="isLesserThanXs ? appearance.privateArea.header.logo.front.compact.height+'px' : appearance.privateArea.header.logo.front.regular.height+'px'" 
                         [frontImageWidth]="isLesserThanXs ? appearance.privateArea.header.logo.front.compact.width+'px' : appearance.privateArea.header.logo.front.regular.width+'px'" >
      </app-flipping-logo>
    </div>
    <!-- 
    RIGHT SECTION
    -->
    <div class="horizontal layout right middle" style="position: absolute; right: 8px; z-index: 1;">
      <!-- 
      PROFILE
      -->
      <app-profile-section *ngIf="appearance.privateArea.header.profileSection.show"></app-profile-section>
      
      <!-- 
      LANGUAGE CHOOSER
      -->
      <app-language-chooser *ngIf="appearance.privateArea.header.languageChooser.show"
                              [locales]="locales"
                              [fontColor]="appearance.privateArea.header.fontColor">
      </app-language-chooser>
      <!-- 
      MORE ACTIONS BUTTON
      -->
      <button mat-icon-button *ngIf="appearance.privateArea.header.moreMenu.show"
              [matMenuTriggerFor]="settingsMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #settingsMenu="matMenu">
        <!-- 
        CHOSE LANGUAGE
        -->
        <ng-container *ngIf="appearance.privateArea.header.moreMenu.languageChooser.show">
          <button mat-menu-item disabled>
            <span>{{'HEADER.LANGUAGE' | translate}}</span>
          </button>
          <button mat-menu-item *ngFor="let option of locales"
                  (click)="localeDataService.setLocale(option.id)"
                  [class.selected]="isSelectedLocale(localeDataService.locale, option.id)">
            <span>{{option.label}}</span>
          </button>
        </ng-container>
        
        <mat-divider *ngIf="appearance.privateArea.header.moreMenu.languageChooser.show && appearance.privateArea.header.moreMenu.about.show"></mat-divider>

        <!-- 
        ABOUT
        -->
        <ng-container *ngIf="appearance.privateArea.header.moreMenu.about.show">
          <button mat-menu-item (click)="showAbout()">
            {{'HEADER.ABOUT' | translate}}
          </button>
        </ng-container>
      </mat-menu>
    </div>
    <!--
    MENU (absolute - effetto finale: centrato orizzontalmente)
    -->
    <div class="layout horizontal center middle" style="width: 100%; position: absolute; z-index: 0;">
      <ng-container *ngIf="!isMobile">
        <app-horizontal-menu *ngIf="appearance.privateArea.header.menu && appearance.privateArea.header.menu.show"
                            context="private"
                            [settings]="{mode: appearance.publicArea.header.menu.mode,
                              spacing: appearance.publicArea.header.menu.spacing,
                              menuItemStyle: {
                                  fontSize: appearance.publicArea.header.menu.fontSize,
                                  fontColor: appearance.publicArea.header.menu.fontColor,
                                  bgColor: appearance.publicArea.header.menu.bgColor,
                                  borderColor: appearance.publicArea.header.menu.borderColor,
                                  underlineColor: appearance.publicArea.header.menu.underlineColor
                              },
                              hoverMenuItemStyle: {
                                  fontColor: appearance.publicArea.header.menu.hoverItemFontColor,
                                  bgColor: appearance.publicArea.header.menu.hoverItemBgColor,
                                  borderColor: appearance.publicArea.header.menu.hoverItemBorderColor,
                                  underlineColor: appearance.publicArea.header.menu.hoverItemUnderlineColor
                              },
                              selectedMenuItemStyle: {
                                  fontColor: appearance.publicArea.header.menu.selectedItemFontColor,
                                  bgColor: appearance.publicArea.header.menu.selectedItemBgColor,
                                  borderColor: appearance.publicArea.header.menu.selectedItemBorderColor,
                                  underlineColor: appearance.publicArea.header.menu.selectedItemUnderlineColor
                              }}">
        </app-horizontal-menu>
      </ng-container>
    </div>
</div>